export function FinalCTA() {
  return (
    <section className="py-20 bg-gradient-to-br from-orange-500 to-orange-600">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center text-white">
          <h2 className="text-4xl lg:text-6xl font-bold mb-6">
            Ready to Sell Your Small Apartment Building?
          </h2>
          <p className="text-xl lg:text-2xl mb-12 max-w-3xl mx-auto opacity-95">
            Get a fair cash offer for your duplex, triplex, quadplex, or 5-unit building today. No fees, no repairs, no hassle.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center mb-16">
            <a 
              href="#get-offer"
              className="inline-flex items-center justify-center px-10 py-5 bg-white text-orange-600 font-bold text-lg rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap shadow-xl"
            >
              Get Your Cash Offer Now
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a 
              href="tel:+1234567890"
              className="inline-flex items-center justify-center px-10 py-5 bg-transparent border-2 border-white text-white font-bold text-lg rounded-lg hover:bg-white hover:text-orange-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Call Us: (123) 456-7890
            </a>
          </div>

          <div className="grid md:grid-cols-4 gap-8 max-w-5xl mx-auto">
            <div>
              <div className="text-5xl font-bold mb-2">500+</div>
              <p className="text-lg opacity-90">Properties Purchased</p>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">7-14</div>
              <p className="text-lg opacity-90">Days to Close</p>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">$0</div>
              <p className="text-lg opacity-90">Fees or Commissions</p>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">100%</div>
              <p className="text-lg opacity-90">Satisfaction Rate</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}